// src/components/When.tsx
import { Fragment, jsx } from "react/jsx-runtime";
function evaluateCondition(condition) {
  return typeof condition === "function" ? condition() : condition;
}
function When({
  condition,
  children,
  fallback = null
}) {
  if (!evaluateCondition(condition)) return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  return /* @__PURE__ */ jsx(Fragment, { children });
}

export {
  When
};
